import standardAPI from '@/api/standard_items';

const responseUrl = '/hotels/parameters';

const state = {
  parameters: [],
  parameters_MetaData: {},
  parameters_status: '',
  parameters_page: 1,
  parameters_perPage: 10,
};

const getters = {
  get_parameters: (state) => {
    return state.parameters;
  },
  get_parameters_status: (state) => {
    return state.parameters_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_parameters ({ commit }, getOptions) {
    commit('DATA_PARAMETERS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_PARAMETERS_UPDATE_SUCCESS', response);
            commit('DATA_PARAMETERS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_PARAMETERS_READY');
            reject(response);
          } else {
            commit('DATA_PARAMETERS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_parameters_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_parameter ({ commit, dispatch }, itemData) {
    commit('DATA_PARAMETERS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_PARAMETERS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_PARAMETERS_READY');
          reject(response);
        }
      });
    });
  },
  edit_parameter ({ commit, dispatch }, itemData) {
    commit('DATA_PARAMETERS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_PARAMETERS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_PARAMETERS_READY');
          reject(response);
        }
      });
    });
  },
  remove_parameters ({ commit, dispatch }, itemData) {
    commit('DATA_PARAMETERS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_PARAMETERS_REQUEST');
          resolve();
        } else {
          commit('DATA_PARAMETERS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_parameter ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_parameter_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.parameters_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.parameters_perPage = max;
  },
  DATA_PARAMETERS_READY: (state) => {
    state.parameters_status = 'ready';
  },
  DATA_PARAMETERS_REQUEST: (state) => {
    state.parameters_status = 'loading';
  },
  DATA_PARAMETERS_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.parameters_MetaData.meta = response.meta;
      state.parameters_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.parameters = response.data || [];
    }
    state.parameters_status = 'success';
  },
  DATA_PARAMETERS_ERROR: (state) => {
    state.parameters_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
